module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-base-6.040292e7.png";